<template>
    <div v-if="isLoaded">
        <div
            class="content-body"
            v-bind:class="{ fullscreen_expand: isFullscreen }"
        >
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card" style="">
                        <div class="card-header">
                            <v-tour
                                name="OCsTour"
                                :steps="steps"
                                :callbacks="callbacksTour"
                            ></v-tour>
                            <h4 class="card-title step-inicio">
                                Pallets
                            </h4>
                            <div class="heading-elements">
                                <ul class="list-inline mb-0">
                                    <li>
                                        <a
                                            @click="onCreate()"
                                            v-b-tooltip
                                            title="Cadastrar"
                                            v-if="
                                                getPermissionFw('pallet.store')
                                            "
                                            ><i
                                                class="fa fa-plus step-cadastrar"
                                            ></i
                                        ></a>
                                    </li>
                                    <li>
                                        <a
                                            @click="
                                                onChangeStatus(1, null, true)
                                            "
                                            v-b-tooltip
                                            title="Ativar Registros"
                                            v-if="
                                                getPermissionFw('pallet.status')
                                            "
                                            ><i
                                                class="fa fa-thumbs-o-up step-ativar"
                                            ></i
                                        ></a>
                                    </li>
                                    <li>
                                        <a
                                            @click="
                                                onChangeStatus(2, null, true)
                                            "
                                            v-b-tooltip
                                            title="Inativar Registros"
                                            v-if="
                                                getPermissionFw('pallet.status')
                                            "
                                            ><i
                                                class="fa fa-thumbs-o-down step-desativar"
                                            ></i
                                        ></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div
                                class="table-responsive"
                                style="min-height: 72vh;"
                            >
                                <div
                                    v-if="vuetableFilterRow"
                                    class="step-filtrar"
                                >
                                    <vuetable-filterbar> </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData" v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner
                                                v-if="loadingData"
                                                text-fg-color="#ffffff"
                                                message="Carregando..."
                                            ></spinner>
                                        </div>
                                    </div>
                                    <div>
                                        <a
                                            @click="searchAll()"
                                            v-b-tooltip
                                            title="Selecionar todas as páginas"
                                            v-if="
                                                getPermissionFw(
                                                    'ordemcoleta.index'
                                                )
                                            "
                                            ><i
                                                class="fa fa-check-square-o fa-lg"
                                                style="margin: 0px 0px 5px 4px"
                                            ></i
                                        ></a>
                                    </div>
                                    <vuetable
                                        ref="vuetable"
                                        api-url="/api/pallet"
                                        :fields="fields"
                                        :css="css"
                                        :append-params="moreParams"
                                        track-by="pallet_id"
                                        pagination-path="meta"
                                        @vuetable:pagination-data="
                                            onPaginationData
                                        "
                                        @vuetable:loaded="onLoaded"
                                        :load-on-start="false"
                                        :no-data-template="noDataText"
                                    >
                                        <template
                                            slot="status"
                                            slot-scope="props"
                                        >
                                            <span
                                                class="badge badge-success"
                                                v-if="
                                                    props.rowData.status
                                                        .valor == 1
                                                "
                                                >{{
                                                    props.rowData.status.descr
                                                }}</span
                                            >
                                            <span
                                                class="badge badge-danger"
                                                v-if="
                                                    props.rowData.status
                                                        .valor == 2
                                                "
                                                >{{
                                                    props.rowData.status.descr
                                                }}</span
                                            >
                                        </template>
                                        <template
                                            slot="actions"
                                            slot-scope="props"
                                        >
                                            <div class="custom-actions">
                                                <a
                                                    @click="
                                                        onEdit(props.rowData)
                                                    "
                                                    v-b-tooltip
                                                    title="Editar"
                                                    v-if="
                                                        getPermissionFw(
                                                            'pallet.update'
                                                        )
                                                    "
                                                    ><i class="fa fa-edit"></i
                                                ></a>
                                                <span
                                                    v-if="
                                                        getPermissionFw(
                                                            'pessoa.status'
                                                        )
                                                    "
                                                >
                                                    <a
                                                        v-if="
                                                            props.rowData.status
                                                                .valor == 2
                                                        "
                                                        @click="
                                                            onChangeStatus(
                                                                1,
                                                                props.rowData,
                                                                false
                                                            )
                                                        "
                                                        v-b-tooltip
                                                        title="Ativar"
                                                        ><i
                                                            class="fa fa-thumbs-o-up"
                                                        ></i
                                                    ></a>
                                                    <a
                                                        v-if="
                                                            props.rowData.status
                                                                .valor == 1
                                                        "
                                                        @click="
                                                            onChangeStatus(
                                                                2,
                                                                props.rowData,
                                                                false
                                                            )
                                                        "
                                                        v-b-tooltip
                                                        title="Inativar"
                                                        ><i
                                                            class="fa fa-thumbs-o-down"
                                                        ></i
                                                    ></a>
                                                </span>
                                                <span v-if="getPermissionFw('area.print_qrcode')">
                                                    <a @click="onGenerateQrCode(props.rowData)" v-b-tooltip title="Gerar QRCode">
                                                        <i class="fa fa-print"></i>
                                                    </a>
                                                </span>
                                            </div>
                                        </template>
                                    </vuetable>
                                </div>
                                <div class="col-md-12">
                                    <div class="pull-left pagination-detail">
                                        <vuetable-pagination-info
                                            ref="paginationInfo"
                                            :css="css.pagination"
                                            info-class="pull-left"
                                        ></vuetable-pagination-info>
                                    </div>
                                    <div class="pull-right m-a-0">
                                        <vuetable-pagination
                                            ref="pagination"
                                            :css="css.pagination"
                                            @vuetable-pagination:change-page="
                                                onChangePage
                                            "
                                        ></vuetable-pagination>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PalletForm ref="pallet_form" :refreshTable="onFilterReset">
        </PalletForm>
    </div>
</template>

<script>
import accounting from "accounting";
import moment from "moment";
import PalletFilterBar from "./PalletFilterBar";
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import PalletForm from "./PalletForm";
import ReturnApi from "../ReturnApi";

export default {
    name: "palletTour",
    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationInfo,
        PalletForm,
        "vuetable-filterbar": PalletFilterBar,
    },
    data() {
        return {
            callbacksTour: {
                onNextStep: this.tourNextStepCallback,
                onStop: this.tourStop,
            },
            steps: [
                {
                    target: ".step-inicio",
                    content: `Para acessar um pallet é muito fácil. <strong>Veja nossas dicas básicas</strong> para utilizar a tela e as funcionalidades disponíveis`,
                },
                {
                    target: ".step-cadastrar",
                    content:
                        "Para cadastrar um novo pallet, basta clicar no botão ao lado.",
                    params: {
                        placement: "left",
                    },
                },
                {
                    target: ".step-ativar",
                    content:
                        "Para ativar um pallet, você deve selecionar o(s) pallet(s) e clicar no botão ao lado.",
                    params: {
                        placement: "left",
                    },
                },
                {
                    target: ".step-desativar",
                    content:
                        "Para desativar um pallet, você deve selecionar o(s) pallet(s) e clicar no botão ao lado.",
                    params: {
                        placement: "left",
                    },
                },
                {
                    target: ".step-filtrar",
                    content:
                        "Para filtrar uma ordem em específico, você pode utilizar de diversos filtros.",
                    params: {
                        placement: "top",
                    },
                },
            ],
            date_attributes: [
                { key: "today", highlight: true, dates: new Date() },
            ],
            firstLoad: true,
            loading: false,
            loadingData: false,
            filter_data_store: {},
            filtrosForm: new Form({
                cd: "",
                qrcode: "",
                capacidade_kg: "",
                capacidade_m3: "",
                status: "",
            }),
            statusForm: new Form({
                pallet_ids: [],
                status: null,
            }),
            fields: [
                {
                    name: "__checkbox",
                    titleClass: "center aligned",
                    dataClass: "center aligned",
                },
                {
                    name: "cd",
                    title: "Código",
                },
                {
                    name: "capacidade_kg",
                    title: "Capacidade em Kg",
                    callback: this.formatNumber,
                },
                {
                    name: "capacidade_cubado",
                    title: "Capacidade m³",
                    callback: this.formatNumber,
                },
                {
                    name: "",
                    title: "Dimensão",
                    callback: this.formatPalletDimension,
                },
                {
                    name: "__slot:status",
                    title: "Status",
                    sortField: "status",
                },
                {
                    name: "__slot:actions",
                    title: "Ações",
                    titleClass: "center aligned",
                    dataClass: "center aligned",
                },
            ],
            css: {
                tableClass: "table",
                loadingClass: "loading",
                ascendingIcon: "glyphicon glyphicon-chevron-up",
                descendingIcon: "glyphicon glyphicon-chevron-down",
                handleIcon: "glyphicon glyphicon-menu-hamburger",
                detailRowClass: "vuetable-detail-row",
            },
            moreParams: {},
        };
    },
    mounted() {
        this.$events.$on("filter-set", (eventData) =>
            this.onFilterSet(eventData)
        );
        this.$events.$on("filter-reset", (eventData) =>
            this.onFilterReset(eventData)
        );
    },
    methods: {
        throwErrorNotSelected() {
            return this.$Simplert.open({
                title: "Atenção",
                message: "Selecione pelo menos um pallet!",
                customCloseBtnText: "Fechar",
                type: "error",
            });
        },
        searchAll(data_filter, tipo) {
            if (tipo == 2) {
                this.filter_data_store = data_filter;
            }
            if (tipo != 2) {
                this.loadingData = true;
                if (this.$refs.vuetable.selectedTo.length == 0) {
                    this.filtrosForm.cd = this.filter_data_store.cd;
                    this.filtrosForm.qrcode = this.filter_data_store.qrcode;
                    this.filtrosForm.capacidade_kg = this.filter_data_store.capacidade_kg;
                    this.filtrosForm.capacidade_m3 = this.filter_data_store.capacidade_m3;
                    this.filtrosForm.status = this.filter_data_store.status;
                    this.filtrosForm
                        .post("/api/pallet/all")
                        .then((response) => {
                            new ReturnApi(response, this, true, false, false);
                            response.forEach((obj) => {
                                this.$refs.vuetable.selectedTo.push(
                                    parseFloat(obj)
                                );
                            });
                            this.loadingData = false;
                        })
                        .catch((errors) => {
                            new ReturnApi(errors, this);
                            this.loadingData = false;
                        });
                } else {
                    this.$refs.vuetable.selectedTo = [];
                    this.loadingData = false;
                }
            }
        },
        startTour() {
            this.$tours["OCsTour"].start();
        },
        tourNextStepCallback(currentStep) {
            // if(currentStep) Abrir o menu com opções
        },
        tourStop() {},
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        onFilterSet(data_filter) {
            this.firstLoad = false;
            this.loadingData = true;
            this.moreParams = {
                cd: data_filter.cd,
                qrcode: data_filter.qrcode,
                capacidade_kg: data_filter.capacidade_kg,
                capacidade_m3: data_filter.capacidade_m3,
                status: data_filter.status,
            };
            if (JSON.stringify(this.moreParams) != "{}") {
                this.searchAll(this.moreParams, 2);
            }
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onFilterReset(data_filter) {
            this.$refs.vuetable.selectedTo = [];
            this.onFilterSet(data_filter);
        },
        onLoaded() {
            this.loadingData = false;
            this.$store.commit("setVuetableFilterButton", false);
        },
        onEdit(data) {
            this.$refs.pallet_form.onEdit(data);
        },
        onCreate() {
            this.$refs.pallet_form.onCreate();
        },
        onChangeStatus(status, selectedPallet, multiples) {
            this.statusForm.status = status;
            // se for múltiplos pallets, irá mudar o status de todos selecionados
            if (multiples) {
                this.statusForm.pallet_ids = [];
                this.$refs.vuetable.selectedTo.forEach((pallet_id) => {
                    this.statusForm.pallet_ids.push(pallet_id);
                });
            } else {
                this.statusForm.pallet_ids = [selectedPallet.pallet_id];
            }
            if (this.statusForm.pallet_ids.length == 0) {
                return this.throwErrorNotSelected();
            }
            this.statusForm
                .patch("/api/pallet/status")
                .then((response) => {
                    new ReturnApi(response, this);
                })
                .catch((errors) => {
                    new ReturnApi(errors, this);
                });
        },
        formatNumber(value) {
            return accounting.formatNumber(value, 2);
        },
        formatDate(value, fmt = "D MMM YYYY") {
            return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
        },
        formatDateSubmit(value, fmt = "DD/MM/YYYY HH:mm:ss") {
            return value == null || value == ""
                ? ""
                : moment(value, "YYYY/MM/DD HH:mm:ss").format(fmt);
        },
        formatPalletDimension(pallet) {
            var largura = pallet.dimensao_largura || 0;
            var comprimento = pallet.dimensao_comprimento || 0;

            if (largura == 0 && comprimento == 0) {
                return "(não informado)";
            }

            return `${largura}cm x ${comprimento}cm`;
        },
        onGenerateQrCode(data) {
            this.statusForm
                .get("/api/pallet/printqrcode/" + data.pallet_id)
                .then((response) => {
                    new ReturnApi(response, this);
                })
                .catch((errors) => {
                    new ReturnApi(errors, this);
            });
        }
    },
    computed: {
        vuetableFilterRow: {
            get() {
                return this.$store.getters.vuetable.filterRow;
            },
        },
        apiVersion: {
            get() {
                return this.$store.getters.api_version;
            },
        },
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            },
        },
        isFullscreen: {
            get() {
                return this.$store.getters.is_full_screen;
            },
        },
        noDataText: {
            get() {
                if (this.firstLoad) {
                    return "Clique em filtrar para carregar os pallets.";
                } else {
                    return "Nenhum registro encontrado.";
                }
            },
        },
    },
};
</script>
